export const DATE_FORMATS = {
  display: "DD-MM-YYYY",
  datetime: "DD-MM-YYYY, hh:mma",
  api: "YYYY-MM-DD",
  iso: "iso",
} as const;

export type DateFormatName = keyof typeof DATE_FORMATS;
export type DateFormatPattern = (typeof DATE_FORMATS)[DateFormatName];
